import { AbstractControl, ValidatorFn } from '@angular/forms';

// @dynamic
export class CustomInputDateValidator {

    static validateDate(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {

            const validationRegex = /^[0-9]{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
            if (control.value && !validationRegex.test(control.value)) {
                return { date: { valid: false, messageKey: 'invalidDate'} };
            }
            return null;
        };
    }
}
